import React from 'react';

class DMEAddressContainer extends React.Component {
    render() {
        return (
            <div className="dme-address-container">
                <h5>Suite 2, Level 2</h5>
                <h5>59-75 Grafton Street</h5>
                <h5>Bondi Junction, NSW, 2022</h5>
                <h5>Australia</h5>
            </div>
        );
    }
}

export default DMEAddressContainer;



// WEBPACK FOOTER //
// ./src/components/Footer/DMEAddressContainer.js